import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import type { Tab } from 'shared/components/Form/types'

export const useProductSettingsTabs = (): Tab[] => {
	const { t } = useTranslation()

	return [
		{ label: t('Categories'), value: routes.categoryIndex },
		{ label: t('Fabrics'), value: routes.fabricIndex },
		{ label: t('Conditions'), value: routes.conditionIndex },
		{ label: t('Genders'), value: routes.genderIndex },
		{ label: t('Types'), value: routes.typeIndex },
		{ label: t('Tags'), value: routes.tagIndex }
	]
}
